import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { isAuthenticatedGuard } from '@app/core/guard/is-authenticated.guard';

import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'batchpayments',
    loadChildren: () => import('./batch-payment/batch-payment.module').then(m => m.BatchPaymentModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'beneficiaries',
    loadChildren: () => import('./beneficiary/beneficiary.module').then(m => m.BeneficiaryModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'beneficiarygroups',
    loadChildren: () => import('./beneficiary-group/beneficiary-group.module').then(m => m.BeneficiaryGroupModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'countries',
    loadChildren: () => import('./country/country.module').then(m => m.CountryModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'funding',
    loadChildren: () => import('./funding/funding.module').then(m => m.FundingModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'donations',
    loadChildren: () => import('./donation/donation.module').then(m => m.DonationModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'fieldaffiliates',
    loadChildren: () =>
      import('./organisation/field-affiliate/field-affiliate.module').then(m => m.FieldAffiliateModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'localpartners',
    loadChildren: () => import('./local-partner/local-partner.module').then(m => m.LocalPartnerModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'organisations',
    loadChildren: () => import('./organisation/organisation.module').then(m => m.OrganisationModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'payments',
    loadChildren: () => import('./donation/payment.module').then(m => m.PaymentModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'payouts',
    loadChildren: () => import('./payout/payout.module').then(m => m.PayoutModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'projects',
    loadChildren: () => import('./organisation/project/project-routing.module').then(m => m.ProjectRoutingModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'questionnaire/forms',
    loadChildren: () => import('./questionnaire-form/questionnaire-form.module').then(m => m.QuestionnaireFormModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'questionnaires',
    loadChildren: () => import('./questionnaire/questionnaire.module').then(m => m.QuestionnaireModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'questions',
    loadChildren: () => import('./question/question.module').then(m => m.QuestionModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'questioncategories',
    loadChildren: () => import('./question-category/question-category.module').then(m => m.QuestionCategoryModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'quests',
    loadChildren: () => import('./quest/quest.module').then(m => m.QuestModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'system',
    loadChildren: () => import('./system/system.module').then(m => m.SystemModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'surveys',
    loadChildren: () => import('./survey/survey.module').then(m => m.SurveyModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'tasks',
    loadChildren: () => import('./task/task.module').then(m => m.TaskModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'users',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'workflow',
    loadChildren: () => import('./workflow/workflow.module').then(m => m.WorkflowModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'signin-callback',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'signout-callback',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
